/**
 * Mobile drawer Benefits row — link navigates; toggle button expands pillar grid.
 */
class BenefitsDrawerRow extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const toggle = this.querySelector('.menu-drawer__dual-row-toggle');
    const panel = this.querySelector('.menu-drawer__benefits-panel');

    if (!(toggle instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    const { signal } = this.#controller;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      this.#setExpanded(toggle, panel, toggle.getAttribute('aria-expanded') !== 'true');
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {HTMLButtonElement} toggle
   * @param {HTMLElement} panel
   * @param {boolean} expanded
   */
  #setExpanded(toggle, panel, expanded) {
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute(
      'aria-label',
      expanded ? toggle.dataset.labelHide : toggle.dataset.labelShow
    );

    if (expanded) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('benefits-drawer-row')) {
  customElements.define('benefits-drawer-row', BenefitsDrawerRow);
}
